import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { ConfirmDialogComponent } from 'projects/shared/lib/components/shared/base/dialog/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-confirm-dialog',
    imports: [
    FormsModule
],
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogMHComponent extends ConfirmDialogComponent { }
